if (!customElements.get('loyalty-rewards-birthday-modal')) {
  customElements.define(
    'loyalty-rewards-birthday-modal',
    // eslint-disable-next-line no-undef
    class LoyaltyRewardsBirthdayModal extends window.BAO.CustomElement() {
      constructor () {
        super()

        const observerConfig = {
          childList: true,
          subtree: true,
        }

        const mutationObserver = new MutationObserver(this.handleMutation.bind(this))
        mutationObserver.observe(document.documentElement, observerConfig)

        const successObserverConfig = {
          childList: true,
          subtree: true,
        }

        const successObserver = new MutationObserver(this.handleSuccessMutation.bind(this))
        successObserver.observe(document.documentElement, successObserverConfig)
      }

      handleMutation (mutationsList, observer) {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'childList') {
            const lionBirthdayModal = document?.querySelector('.lion-birthday-action')

            if (lionBirthdayModal) {
              const helpElement = lionBirthdayModal.querySelector('.lion-birthday-action__help')

              if (helpElement) {
                if (!helpElement.nextElementSibling || !helpElement.nextElementSibling.classList.contains('lion-birthday-action__help-new')) {
                  const newDiv = document.createElement('div')
                  newDiv.className = 'lion-birthday-action__help-new'
                  newDiv.textContent = this.dataset.textEnter
                  helpElement.insertAdjacentElement('afterend', newDiv)
                }
              }
            }
          }
        })
      }

      handleSuccessMutation (mutationsList, observer) {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'childList') {
            const successElement = document.querySelector('.lion-birthday-action__success')
            if (successElement) {
              const helpNewElement = document.querySelector('.lion-birthday-action__help-new')
              if (helpNewElement) {
                helpNewElement.remove()
              }
              
              if (!successElement.nextElementSibling || !successElement.nextElementSibling.classList.contains('lion-birthday-action__success-new')) {
                const newDiv = document.createElement('div')
                newDiv.className = 'lion-birthday-action__success-new'
                newDiv.textContent = this.dataset.textSuccess
                successElement.insertAdjacentElement('afterend', newDiv)

                this.externalEls.button?.elements.forEach(buttonExternalEl => {
                  if (buttonExternalEl) {
                    buttonExternalEl.textContent = buttonExternalEl.dataset.completedText
                    buttonExternalEl.parentElement.classList.add('loy-RewardsCarousel_SlideTier-complete')
                  }
                })
              }
            }
          }
        })
      }
    },
  )
}
